import { render } from "./modify-account.vue?vue&type=template&id=25aa200e"
import script from "./modify-account.vue?vue&type=script&lang=js"
export * from "./modify-account.vue?vue&type=script&lang=js"

import "./modify-account.vue?vue&type=style&index=0&id=25aa200e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__